package com.rosario.juridico.marketplace.viewmodel

import com.rosario.juridico.domain.DirectorioAbogadosRepository
import com.rosario.juridico.domain.DirectorioResult
import com.rosario.juridico.domain.PerfilAbogadoDataModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class DirectorioViewModel(
    private val directorioRepository: DirectorioAbogadosRepository = DirectorioAbogadosRepository()
) {
    private val scope = CoroutineScope(Dispatchers.Main)

    private val _directorioAbogadosState = MutableStateFlow<UiState<List<PerfilAbogadoDataModel>>>(UiState.Idle)
    val directorioAbogadosState: StateFlow<UiState<List<PerfilAbogadoDataModel>>> = _directorioAbogadosState

    private val _filtroEspecialidadDirectorio = MutableStateFlow("Todas")
    val filtroEspecialidadDirectorio: StateFlow<String> = _filtroEspecialidadDirectorio.asStateFlow()

    private val _filtroLocalidadDirectorio = MutableStateFlow("Todas")
    val filtroLocalidadDirectorio: StateFlow<String> = _filtroLocalidadDirectorio.asStateFlow()

    private val _queryBusquedaDirectorio = MutableStateFlow("")
    val queryBusquedaDirectorio: StateFlow<String> = _queryBusquedaDirectorio.asStateFlow()

    init {
        loadDirectorioAbogados()
    }

    /**
     * Carga los abogados verificados (NIVEL_3_VERIFICADO) para el Directorio Público (AVVO).
     */
    fun loadDirectorioAbogados() {
        scope.launch {
            _directorioAbogadosState.value = UiState.Loading
            val esp = _filtroEspecialidadDirectorio.value
            val loc = _filtroLocalidadDirectorio.value
            val q = _queryBusquedaDirectorio.value

            when (val result = directorioRepository.getAbogadosVerificados(
                especialidad = if (esp == "Todas") null else esp,
                localidad = if (loc == "Todas") null else loc,
                queryBusqueda = if (q.isBlank()) null else q
            )) {
                is DirectorioResult.Success -> {
                    _directorioAbogadosState.value = UiState.Success(result.data)
                }
                is DirectorioResult.Error -> {
                    _directorioAbogadosState.value = UiState.Error(result.message)
                }
            }
        }
    }

    fun setFiltroEspecialidadDirectorio(esp: String) {
        _filtroEspecialidadDirectorio.value = esp
        loadDirectorioAbogados()
    }

    fun setFiltroLocalidadDirectorio(loc: String) {
        _filtroLocalidadDirectorio.value = loc
        loadDirectorioAbogados()
    }

    fun setQueryBusquedaDirectorio(query: String) {
        _queryBusquedaDirectorio.value = query
        loadDirectorioAbogados()
    }
}
